<template>
	<div v-if="diff" class="flex items-right justify-end space-x-3">
		<div class="flex flex-col items-center justify-center">
			<span class="text-2xl w-12 h-12 font-semibold text-gray-300 bg-gray-700 rounded-xl p-2"> {{ String(milisecondsToTimeObject(diff).days).padStart(2, '0') }} </span>
			<span class="text-xs text-gray-600 mt-1"> días </span>
		</div>
		<div class="flex flex-col items-center justify-center">
			<span class="text-2xl w-12 h-12 font-semibold text-gray-300 bg-gray-700 rounded-xl p-2"> {{ String(milisecondsToTimeObject(diff).hours).padStart(2, '0') }} </span>
			<span class="text-xs text-gray-600 mt-1"> horas </span>
		</div>
		<div class="flex flex-col items-center justify-center">
			<span class="text-2xl w-12 h-12 font-semibold text-gray-300 bg-gray-700 rounded-xl p-2"> {{ String(milisecondsToTimeObject(diff).minutes).padStart(2, '0') }} </span>
			<span class="text-xs text-gray-600 mt-1"> min </span>
		</div>
		<div class="flex flex-col items-center justify-center">
			<span class="text-2xl w-12 h-12 font-semibold text-gray-300 bg-gray-700 rounded-xl p-2"> {{ String(milisecondsToTimeObject(diff).seconds).padStart(2, '0') }} </span>
			<span class="text-xs text-gray-600 mt-1"> seg </span>
		</div>
	</div>
</template>

<script setup lang="ts">
import { dayjs } from '@/services/dayjs'
import { ref, onMounted, onUnmounted } from 'vue'
const diff = ref(null)
const interval = ref(null)
import { Deal } from '../../interfaces/Deal'
const props = defineProps<{ deal: Deal }>()

const update = () => {
	diff.value = dayjs(props.deal.expireDate).diff(dayjs())
	if (diff.value <= 1000) {
		finish()
	}
}

function milisecondsToTimeObject(ms) {
	const days = Math.floor(ms / (1000 * 60 * 60 * 24))
	ms -= days * (1000 * 60 * 60 * 24)

	const hours = Math.floor(ms / (1000 * 60 * 60))
	ms -= hours * (1000 * 60 * 60)

	const minutes = Math.floor(ms / (1000 * 60))
	ms -= minutes * (1000 * 60)

	const seconds = Math.floor(ms / 1000)

	return { days, hours, minutes, seconds }
}

const finish = () => {
	clearInterval(interval.value)
	interval.value = null
}

onMounted(() => {
	update()
	interval.value = setInterval(update, 1000)
})

onUnmounted(() => {
	finish()
})
</script>
